import { consume } from '@lit/context';
import { property } from 'lit/decorators.js';
import { Logger, loggerContext } from '../../providers/logger.context';

import { LitElement } from 'lit';
import { Constructor } from '../types/utils.model';

export declare interface LoggerMixinInterface {
  logger: Logger;
}

export const LoggerMixin = <T extends Constructor<LitElement>>(Base: T) => {
  class LuaBaseComponent extends Base {
    @consume({ context: loggerContext })
    @property({ attribute: false })
    logger?: Logger;
  }

  return LuaBaseComponent as Constructor<LoggerMixinInterface> & T;
};
